export default () =>
  import(/* webpackChunkName: 'coffee/app/download/dispatche' */ './Dispatche');
